export enum AccordionAppearance {
  LIGHT = 'light',
  DARK = 'dark',
}
